module.exports = "import React from 'react';\nimport DayPicker from 'react-day-picker';\n\nimport 'react-day-picker/lib/style.css';\n\nexport default class BasicConcepts extends React.Component {\n  render() {\n    return (\n      <div>\n        <DayPicker />\n      </div>\n    );\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/code-samples/basic-concepts-01.js
// module id = 757
// module chunks = 168707334958949